import {combineReducers} from 'redux-immutable';

import OnlineExamination from './component';
import mainReducer from './reducer';
import treeReducer from '../tree/reducer';


export const initialState = undefined;

export const reducer = combineReducers({
    main: mainReducer,
    materialsTree: treeReducer,
});

export const component = OnlineExamination;
